<script lang="ts" setup>
const { car = {} } = defineProps<{ car: any }>();

const { t } = useI18n({
  useScope: "global",
});
const carsStore = useSelectedCars();

const isCarSelected = computed(() => {
  return carsStore.isCarSelected(car.id);
});

const toggleCarSelection = (test) => {
  if (typeof test !== 'boolean') {
    carsStore.toggleCarSelection(car.id);
    return;
  }
  if (test) {
    carsStore.addCar(car.id);
  } else {
    carsStore.removeCar(car.id);
  }
};

const selected = ref(false);
watch(
  () => isCarSelected.value,
  (value) => {
    selected.value = value;
  },
  { immediate: true }
);

const carFlags = computed(() => {
  return car?.flags || [];
});

const getCarFlag = (flag) => {
  const flags = unref(carFlags)
  return flags.find((f) => f.type === flag)
};

provide("carsItem", { car });
</script>

<template>
  <div class="car-list-item">
    <div class="item">
      <div class="item__top">
        <div class="item__image-slot">
          <slot
            name="featured-image"
            :car="car"
          />
        </div>

        <div class="item__info">
          <div
            class="item__info-header"
            @click.self="toggleCarSelection"
          >
            <h4
              class="item__info-title"
              @click.self="toggleCarSelection"
            >
              {{ car.title }}
              <Icon
                v-if="getCarFlag('NOTIFICATION')"
                name="badge"
              />
            </h4>
            <FormKit
              :id="`car-selector-${car.id}`"
              v-model="selected"
              type="checkbox"
              variant="no-border"
              outer-class="item__info-checkbox"
              @input="toggleCarSelection"
            />
          </div>


          <div class="item__info-column">
            <slot
              name="info-column-1"
              :car="car"
            />
          </div>
          <!----------->
          <div class="item__info-column">
            <slot
              name="info-column-2"
              :car="car"
            />
          </div>
          <!----------->
          <div class="item__info-column">
            <slot
              name="info-column-3"
              :car="car"
            />
          </div>
          <!----------->
          <div class="item__info-column">
            <slot
              name="info-column-4"
              :car="car"
            />
          </div>
          <!----------->
        </div>
      </div>
      <slot
        name="footer"
        :car="car"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.item__info-checkbox {
  display: inline-block;
  margin: 0;
  :deep(.indigo-ui-wrapper) {
    padding: 0;
    padding-left: 10px;
  }
}
.car-list-item {
  margin-bottom: 15px;

  &:last-child {
    margin-bottom: 0;
  }

  .item {
    position: relative;
    width: 100%;
    background: #ffffff;
    border: 1px solid rgba(45, 45, 134, 0.2);
    border-radius: 5px 10px 10px 10px;
    overflow: hidden;

    &__image-slot {
      width: 200px;
      height: auto;

      @media only screen and (max-width: $laptopS) {
        width: 100%;
      }

      @media only screen and (max-width: $tablet) {

      }
    }
    &__top {
      display: flex;
      //height: 202px;
      border-bottom: 1px solid rgba(45, 45, 134, 0.2);
      @media only screen and (max-width: $laptopS) {
        flex-direction: column;
        height: auto;
      }
    }

    &__info {
      display: flex;
      justify-content: space-between;
      flex: 1;
      flex-wrap: wrap;
      padding: 20px;

      @media only screen and (max-width: $laptopS) {
        overflow: auto;
      }

      @media only screen and (max-width: $tablet) {
        padding: 10px;
        flex-direction: column;
      }

      &-column {
        max-width: 25%;
        padding-right: 10px;

        &:last-child {
          flex-wrap: nowrap;
        }

        @media only screen and (max-width: $tablet) {
          max-width: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }
      }

      &-header {
        display: flex;
        justify-content: space-between;
        width: 100%;
        cursor: pointer;
      }
      &-title {
        font-weight: 700;
        font-size: 14px;
        margin-bottom: 15px;

        max-width: 700px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        @media only screen and (max-width: $tablet) {
          width: 100%;
        }
      }

      &-item {
        display: flex;
        flex-direction: column;
        font-size: 12px;
        margin-bottom: 15px;

        @media only screen and (max-width: $tablet) {
          margin-bottom: 10px;
          min-width: 50%;
          white-space: nowrap;
          font-size: 11px;
        }

        &.row {
          flex-direction: row;
          align-items: center;
          margin-bottom: 12px;

          .title {
            margin-right: 5px;
            margin-bottom: 0;
          }
        }

        .title {
          font-weight: 700;
          margin-bottom: 5px;
        }

        .value {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          img {
            width: 60px;
            height: auto;
          }
        }
      }
    }
  }
}
</style>
